import { lerp } from '@/scripts/utils';

class MouseUtil {
  constructor(container, lerpVal) {
    this.container = container;

    this.mouse = {
      handler: {
        move: null,
        enter: null,
        leave: null,
      },
      prevPosition: {
        x: 0,
        y: 0,
        normX: 0,
        normY: 0,
      },
      position: {
        x: 0,
        y: 0,
        normX: 0,
        normY: 0,
      },
      lerpedPosition: {
        x: 0,
        y: 0,
        normX: 0,
        normY: 0,
      },
      isInRect: 0,
      lerpVal,
    };

    this.deviceOrientation = {
      handler: null,
      beta: 0,
      gamma: 0,
    };
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.mouse.handler.enter = event => this.mouseEnter(event);
    this.mouse.handler.move = event => this.handleMove(event);
    this.mouse.handler.leave = event => this.mouseLeave(event);
    this.deviceOrientation.handler = event => this.handleMove(event);

    this.container.addEventListener('mouseenter', this.mouse.handler.enter);
    this.container.addEventListener('mousemove', this.mouse.handler.move);
    this.container.addEventListener('mouseleave', this.mouse.handler.leave);
    window.addEventListener('deviceorientation', this.deviceOrientation.handler);
  }

  unbindEvents() {
    this.container.removeEventListener('mouseenter', this.mouse.handler.enter);
    this.container.removeEventListener('mousemove', this.mouse.handler.move);
    this.container.removeEventListener('mouseleave', this.mouse.handler.leave);
    window.removeEventListener('deviceorientation', this.deviceOrientation.handler);
  }

  mouseEnter() {
    this.isInRect = true;
  }

  mouseLeave() {
    this.isInRect = false;

    this.mouse.position.x = 0;
    this.mouse.position.normX = 0;
    this.mouse.position.y = 0;
    this.mouse.position.normY = 0;
  }

  handleMove(event) {
    if (event.type === 'mousemove') {
      const wH = this.container.getBoundingClientRect().width / 2;
      const hH = this.container.getBoundingClientRect().width / 2;

      this.mouse.position.x = event.clientX - wH;
      this.mouse.position.normX = (event.clientX - wH) / wH;
      this.mouse.position.y = event.clientY - hH;
      this.mouse.position.normY = (event.clientY - hH) / hH;
    } else {
      // this.deviceorientation.gamma = event.gamma
      // this.deviceorientation.beta = 54 - event.beta
    }
  }

  getLerpedVal() {
    // if (!this.isInRect) return;

    this.mouse.lerpedPosition.x = lerp(this.mouse.position.x, this.mouse.prevPosition.x, this.mouse.lerpVal);
    this.mouse.lerpedPosition.normX = lerp(this.mouse.position.normX, this.mouse.prevPosition.normX, this.mouse.lerpVal);
    this.mouse.lerpedPosition.y = lerp(this.mouse.position.y, this.mouse.prevPosition.y, this.mouse.lerpVal);
    this.mouse.lerpedPosition.normY = lerp(this.mouse.position.normY, this.mouse.prevPosition.normY, this.mouse.lerpVal);

    this.mouse.prevPosition.x = this.mouse.lerpedPosition.x;
    this.mouse.prevPosition.normX = this.mouse.lerpedPosition.normX;
    this.mouse.prevPosition.y = this.mouse.lerpedPosition.y;
    this.mouse.prevPosition.normY = this.mouse.lerpedPosition.normY;
  }

  get positionX() {
    return this.mouse.position.x;
  }

  get positionNormX() {
    return this.mouse.position.normX;
  }

  get positionLerpedX() {
    return this.mouse.lerpedPosition.x;
  }

  get positionLerpedNormX() {
    return this.mouse.lerpedPosition.normX;
  }

  get positionY() {
    return this.mouse.position.y;
  }

  get positionNormY() {
    return this.mouse.position.normY;
  }

  get positionLerpedY() {
    return this.mouse.lerpedPosition.y;
  }

  get positionLerpedNormY() {
    return this.mouse.lerpedPosition.normY;
  }

  destroy() {
    this.unbindEvents();
  }
}

export default MouseUtil;



// WEBPACK FOOTER //
// ./src/scripts/MouseUtil.js